const widgets = {
  editMode: "Редактирование",
  guideMode: "Гайд",
  library: "Библиотека виджетов",
  size: "Размер",
  hoverDelay: "Задержка наведения",
  none: "Нет",
  seconds: "секунд",
  showWidget: "Показать",
  hideWidget: "Скрыть",
  comingSoon: "Скоро",
  noWidgets: "Нет активных виджетов",
  addWidgets: "Добавить виджеты",
  close: "Закрыть",
  resetSize: "Сбросить размер",
  search: "Поиск",
  searchPlaceholder: "Поиск проектов, документов...",
  recent: "Недавние",
  recentSearches: "Недавние запросы",
  quickActions: "Быстрые действия",
  newProject: "Создать проект",
  newDocument: "Новый документ",
  newTask: "Новая задача",
  noResults: "Нет результатов",
  // Command Palette sections
  commandsSection: "Действия",
  pagesSection: "Страницы",
  widgetsSection: "Виджеты",
  projectsSection: "Проекты",
  wikiSection: "Вики",
  typeCommandHint: "Введите > для команд, / для страниц",
  // Apps Manager tab
  searchTab: "Поиск",
  appsTab: "Приложения",
  appsOnToolbar: "На панели",
  appsInDrawer: "В приложениях",
  appsDisabled: "Отключено",
  appsAddToToolbar: "Добавить на панель",
  appsRemoveFromToolbar: "Убрать с панели",
  appsMoveToApps: "В приложения",
  appsDisableWidget: "Отключить виджет",
  appsActiveWidgets: "Активные виджеты",
  appsAllWidgets: "Все виджеты",
  appsComingSoon: "Скоро",
  projects: "Проекты",
  documents: "Документы",
  conversations: "AI-разговоры",
  aiAssistant: "AI-ассистент",
  aiDescription: "Быстрый AI-ассистент с контекстом страницы",
  ask: "Спросить...",
  context: "Контекст",
  addContext: "Добавить контекст",
  sendMessage: "Отправить",
  typePlaceholder: "Задайте вопрос...",
  suggestSummarize: "Суммировать статус проектов",
  suggestAttention: "Что требует внимания?",
  suggestWrite: "Помогите написать",
  suggestFix: "Исправить ошибки",
  suggestSummarizeDoc: "Суммировать документ",
  suggestToday: "Что сегодня?",
  suggestNewProject: "Создать новый проект",
  sidePanel: "Боковая панель",
  miniWindow: "Мини-окно",
  floatingChat: "Плавающий чат",
  quickCreate: "Быстрое создание",
  quickCreateDesc: "Создать документ или новую сущность",
  newEntity: "Новая сущность",
  new: "Новый",
  newDocAction: "Новый документ",
  newFormalDoc: "Формальный",
  newProjectAction: "Новый проект",
  newTaskAction: "Новая задача",
  create: "Создать",
  titlePlaceholder: "Название...",
  createdToday: "Создано сегодня",
  favorites: "Избранное",
  favoritesDesc: "Сохранённые страницы и ссылки",
  addFavorite: "Добавить в избранное",
  pinPage: "Закрепить страницу",
  unpinPage: "Открепить страницу",
  noFavorites: "Нет избранного",
  todayWidget: "Сегодня",
  todayDesc: "Встречи, дедлайны и напоминания",
  meetings: "Встречи",
  deadlines: "Дедлайны",
  reminders: "Напоминания",
  noEvents: "Нет событий сегодня",
  notifications: "Уведомления",
  notificationsDesc: "Уведомления от проектов, документов и AI",
  markAllRead: "Отметить всё прочитанным",
  noNotifications: "Нет уведомлений",
  unread: "непрочитанных",
  timer: "Таймер",
  timerDesc: "Таймер Помодоро для управления временем",
  timerWork: "Работа",
  timerBreak: "Перерыв",
  timerLongBreak: "Длинный перерыв",
  timerStart: "Старт",
  timerPause: "Пауза",
  timerReset: "Сброс",
  timerSessions: "Сессии",
  clipboard: "Буфер обмена",
  clipboardDesc: "Недавно скопированные элементы",
  clearAll: "Очистить всё",
  noClipboardItems: "Нет элементов",
  copied: "Скопировано",
  clipboardItems: "элементов",
  activeWidgets: "Активные",
  comingSoonWidgets: "Скоро",
  keyboardShortcuts: "Горячие клавиши",
  keyboardShortcutsDesc: "Горячие клавиши и управление действиями",
  shortcutsSearch: "Найти горячую клавишу...",
  shortcutsActive: "Активные",
  shortcutsAll: "Все",
  shortcutsNoResults: "Горячие клавиши не найдены",
  shortcutsAddCustom: "Добавить пользовательскую",
  shortcutsEdit: "Редактировать",
  shortcutsDelete: "Удалить",
  shortcutsConflict: "Конфликт — эта комбинация уже используется",
  shortcutsReset: "Сбросить к стандартным",
  shortcutsSystem: "Системные",
  shortcutsCustom: "Пользовательские",
  shortcutsEnabled: "Включено",
  shortcutsDisabled: "Отключено",
  shortcutsAiSuggest: "Опишите действие для горячей клавиши...",
  shortcutsAiPlaceholder: "Введите и нажмите Enter — AI предложит комбинацию",
  shortcutsKeyCombo: "Комбинация клавиш",
  shortcutsActionName: "Название действия",
  shortcutsScope: "Область",
  shortcutsScopeGlobal: "Глобально",
  shortcutsScopeEditor: "Редактор",
  shortcutsScopeCardBrowser: "Браузер карточек",
  shortcutsScopeTable: "Таблица",
  shortcutsReserved: "Системная",
  // Common widget strings
  allClear: "Всё в порядке",
  soon: "Скоро",
  savedLocally: "сохранено локально",
  langFlag: "RU",
  weeklyPlanner: "Недельный планировщик",
  weeklyPlannerDesc: "Недельное планирование, ежедневные задачи и повторяющиеся шаблоны",
  plannerToday: "Сегодня",
  plannerPersonal: "Мои",
  plannerTeam: "Команда",
  plannerAll: "Все",
  plannerTasks: "задач",
  plannerUrgent: "срочных",
  plannerMeetings: "встреч",
  plannerMember: "Сотрудник",
  plannerTemplates: "Недельные шаблоны",
  plannerApply: "Применить",
  plannerFreeDay: "Свободный день 🎉",
  plannerAdd: "Добавить",
  plannerDone: "Готово",
  plannerMoveToTomorrow: "Перенести на завтра",
  plannerDelete: "Удалить",
  plannerNewTemplate: "Название нового шаблона...",
  plannerCreate: "Создать",
  plannerAddItem: "Добавить пункт",
  plannerNoItems: "Нет пунктов. Добавьте пункты в шаблон.",
  plannerTaskPlaceholder: "Задача + время...",
  plannerCancel: "Отмена",
  plannerAssignMe: "👤 Назначить мне",
  plannerNone: "Нет",
  plannerMe: "я",
  plannerFree: "свободен",
  plannerTitlePlaceholder: "Заголовок...",
  plannerApplyToWeek: "Применить к неделе",
  plannerTemplateDesc: "Создайте шаблон недели с повторяющимися задачами. Применяйте к текущей неделе в один клик.",
  plannerAddTask: "Добавить задачу",
  plannerPriorityUrgent: "Срочно",
  plannerPriorityImportant: "Важно",
  plannerPriorityNormal: "Обычный",
  plannerAddToTemplate: "Добавить элемент в шаблон",
  // AppStore / Widget settings
  categoryAll: "Все",
  selectWidgetToConfigure: "Выберите виджет",
  widgetPlacement: "Расположение",
  widgetSize: "Размер",
  widgetActive: "Активен",
  widgetComingSoon: "Скоро",
  widgetLocked: "Закреплён",
  widgetUnlocked: "Открыт",
  // Search
  semanticResults: "Семантические результаты",
  searchNavigate: "Навигация",
  searchSelect: "Выбрать",
  searchClose: "Закрыть",
  untitled: "Без названия",
  // Settings folder
  allSettings: "Все настройки",
  storeSystem: "Системный",
  storeFolders: "Папки",
  storeCreateFolder: "Создать папку",
  storeActiveCount: "активных",
  store: "Магазин виджетов",
  storeSearch: "Поиск виджетов...",
  storeTabInstalled: "Установленные",
  storeTabAvailable: "Доступные",
  storeTabComingSoon: "Скоро",
  storeBack: "Назад в магазин",
  storePlacement: "Размещение",
  storeSystemWidget: "Системный виджет — нельзя отключить.",
  storeNotifyMe: "Уведомить меня",
  storeNoResults: "Виджеты не найдены",
  placementToolbar: "Панель инструментов",
  placementApps: "Приложения",
  placementDisabled: "Отключено",
  placementDescToolbar: "Виджет отображается в верхней панели и всегда доступен.",
  placementDescApps: "Виджет активен, но доступен только через панель приложений.",
  placementDescDisabled: "Виджет полностью выключен. Ресурсы не используются.",
  categoryBasics: "Основные",
  categoryProductivity: "Продуктивность",
  categoryAiComms: "AI и коммуникации",
  categoryTeam: "Команда",
  categoryAnalytics: "Аналитика",
  categoryIntegrations: "Интеграции",
  appsDrawer: "Приложения",
  appsEmpty: "Пока нет приложений. Переместите виджеты в «Приложения» в магазине.",
  appsHint: "Виджеты в размещении «Приложения» отображаются здесь.",
  // Custom Labels
  customLabel: "Пользовательская метка",
  resetLabel: "Сбросить",
  // Profile Switcher
  profileSwitcher: "Переключатель профилей",
  switchProfile: "Сменить профиль",
  saveAsNew: "Сохранить как новый",
  profileName: "Название профиля...",
  // Display Modes
  displayMode: "Режим отображения",
  displayNormal: "Обычный",
  displayCompact: "Компактный",
  displayIconsOnly: "Только иконки",
  // Auto-Pack
  autoPack: "Упаковать",
  // Panel Modes
  panelMode: "Режим панели",
  panelModeDropdown: "Выпадающее меню",
  panelModeSidePanel: "Боковая панель",
  panelModePopup: "Всплывающее окно",
  // Quick Bookmark
  quickBookmark: "Быстрая закладка",
  bookmarkAdded: "Закладка добавлена",
  openNote: "Открыть заметку",
  // KPI Widget
  kpiOpenProjects: "Открытые проекты",
  kpiDocuments: "Документы",
  kpiActivity7d: "Активность (7 дн.)",
  kpiAvgHealth: "Среднее здоровье",
  kpiQuickMetrics: "Быстрые метрики",
  kpiBar: "KPI",
  // Leads Pipeline Widget
  leadsPipeline: "Воронка лидов",
  leadsPipelineDesc: "Этапы воронки продаж — горизонтальный вид воронки",
  leadsPipelineBar: "Лиды",
  viewAllLeads: "Показать все лиды",
  activeLeads: "Активные лиды",
  stageLead: "Лид",
  stageQualified: "Квалифицирован",
  stageProposal: "Предложение",
  stageNegotiation: "Переговоры",
  stageClosedWon: "Закрыто успешно",
  stageClosedLost: "Закрыто неуспешно",
  // Team Widget
  teamTitle: "Команда",
  teamOnline: "онлайн",
  teamBar: "онлайн",
  // WATI Widget
  watiNoMessages: "Нет новых сообщений",
  watiConfigNote: "Укажите NEXT_PUBLIC_WATI_URL для подключения",
  // External Links Widget
  externalLinksLabelPlaceholder: "Название",
  externalLinksCancel: "Отмена",
  externalLinksAdd: "Добавить",
  externalLinksAddLink: "Добавить ссылку",
  externalLinksReset: "Сбросить",
  externalLinksBar: "Ссылки",
  // Today Widget
  todayLoading: "Загрузка...",
  todayNoEvents: "Нет событий на сегодня.",
} as const;
export default widgets;
